const disabledColor = '#A19F9D'; // Taken from figma, it's not represented in palette

export const getDisabledContentStyle = () => ({
  pointerEvents: 'none',
  opacity: 0.5,
  color: `${disabledColor} !important`,
  '&&&& *': {
    color: disabledColor,
  },
  '&&&& *:after': {
    color: disabledColor,
  },
});
